// eslint-disable-next-line import/no-anonymous-default-export
export default {
  gender: '性別',
  'gender.child': '孩子性別',
  age: '年齡',
  male: '男士',
  female: '女士',
  nonSmoker: '非吸煙者',
  smoker: '吸煙者',
  smokingStatus: '吸煙狀態',
  year: '年',
  years: '年',
  month: '月',
  months: '個月',
  // eslint-disable-next-line no-template-curly-in-string
  'coverage.annualLimit': '保障額<br></br> ${annualLimit}/年',
  // eslint-disable-next-line no-template-curly-in-string
  'coverage.lifetimeLimit': '終身保障限額<br></br> ${lifetimeLimit}',
  'field.attribute_value': '{name}: {value}',
  comparePlans: '比較計劃',
  planDetails: '計劃詳情',
  apply: '立即投保',
  'productMeta.accidentalMedical.description':
    '毋須留下個人資料，亦可預先估計「保泰意外保險-觸木保」的每月保費，立即免費報價！',
  'productMeta.vhis.description':
    '毋須留下個人資料，亦可預先估計Bowtie自願醫保「標準計劃」及「靈活計劃」保費，立即免費報價！',
  'productMeta.medical.description':
    '毋須留下個人資料，亦可預先估計「癌症醫療保險」的每月保費，立即免費報價！',
  'productMeta.life.description':
    '毋須留下個人資料，亦可預先估計「定期人壽保險」的每月保費，立即免費報價！',
  'productMeta.criticalIllness.description':
    '毋須留下個人資料，亦可預先估計「定期危疾保」的每月保費，立即免費報價！',
  'productMeta.parent-medical.description':
    '毋須留下個人資料，亦可預先估計「補充型醫保」的每月保費，立即免費報價！',
  'productMeta.accidentalMedical.name': '意外醫療保險',
  'productMeta.vhis.name': '自願醫保',
  'productMeta.medical.name': '癌症醫療保險',
  'productMeta.life.name': '定期人壽保險',
  'productMeta.criticalIllness.name': '定期危疾保險',
  'productMeta.parent-medical.name': '補充型醫保',
  'productMeta.title': ' - 保費計算機 | Bowtie',
  'coupon.title': '輸入優惠碼',
  'coupon.coupon_code': '輸入優惠碼',
  'coupon.message': '{date}前：{message}',
  'coupon.not_found': '優惠碼不正確',
  'coupon.redeem': '提交',
  'coupon.save': '保存',
  'coupon.saved': '已保存',
  'coupon.save_tooltip': '攞定 code 遲啲先用',
  'coupon.save_modal.title': '而家拎咗先，14 日內隨時用得返！',
  'coupon.save_modal.subtitle': '幫你 hold 住個優惠，記得返嚟用呀',
  'coupon.save_modal.signup_button': '立即註冊',
  'coupon.save_modal.login_link': '登入',
  'coupon.coupon_options': '查看其他可用優惠碼',
  'coupon.coupon_menu.title.header': '可用優惠碼',
  'coupon.coupon_menu.title.saved': '已保存',
  'coupon.coupon_menu.title.public': '公開優惠碼',
  'coupon.coupon_menu.title.existing_customer': 'Bowtie 現有客戶專用',
  'coupon.expired': '已過期',
  'coupon.saved_extension': '已保存並延長{days}天至',
  'coupon.save.error': '保存優惠碼失敗，請重試。',
  'invalid-age': '產品不適用於投保年齡為{age}歲的受保人',
  'sumAssured.label': '選擇或輸入保額',
  'deductible.label': '自付費（請選擇）',
  'termLifeYear.label': '續保年期',
  'termLifeYear.1': '1 年 (保費每年調整)',
  'termLifeYear.5': '5 年 (5年內保費不變，續保時按當時年齡調整)',
  'termLifeYear.10': '10 年 (10年內保費不變，續保時按當時年齡調整)',
  'termLifeYear.20': '20 年 (20年內保費不變，續保時按當時年齡調整)',
  'invalid-sum-assured-range': '保額必須在 {min} 至 {max}',
  'term-and-conditions.1':
    '以上計算的保費僅供參考，你實際需要繳交的保費受時間、通脹、核保等因素影響，並需加上保險業監管局徵收的<a>保費徵費</a>。',
  'term-and-conditions.2': '請下載並查閱標準保費表（<links></links>）',
  'term-and-conditions.3': '請下載並查閱<links></links>。',
  'term-and-conditions.vhis.standard': '標準',
  'term-and-conditions.vhis.flexi-regular': '靈活-基本',
  'term-and-conditions.vhis.flexi-plus': '靈活-升級',
  'term-and-conditions.vhis.flexi-premium-ward': '普通房',
  'term-and-conditions.vhis.flexi-premium-semi-private': '半私家房',
  'term-and-conditions.vhis.flexi-premium-private': '私家房',
  'term-and-conditions.medical.cancer-fighter-100': '戰癌100',
  'term-and-conditions.medical.cancer-fighter-200': '戰癌200',
  'term-and-conditions.medical.cancer-fighter-300': '戰癌300',
  'term-and-conditions.accidental-medical.touch-wood-protector': '標準保費表',
  'term-and-conditions.life.term-life':
    'Bowtie 人壽保標準保費表 (HK$1,000,000 保額)',
  'term-and-conditions.life.term-level-life-5':
    'Bowtie 定期人壽保（5年）標準保費表 (HK$1,000,000 保額)',
  'term-and-conditions.life.term-level-life-10':
    'Bowtie 定期人壽保（10年）標準保費表 (HK$1,000,000 保額)',
  'term-and-conditions.life.term-level-life-20':
    'Bowtie 定期人壽保（20年）標準保費表 (HK$1,000,000 保額)',
  'term-and-conditions.life.last-wish-rider':
    '圓夢保標準保費表 (HK$300,000 保額)',
  'term-and-conditions.life.last-wish-rider-5':
    '圓夢保（5年）標準保費表 (HK$300,000 保額)',
  'term-and-conditions.life.last-wish-rider-10':
    '圓夢保（10年）標準保費表 (HK$300,000 保額)',
  'term-and-conditions.life.last-wish-rider-20':
    '圓夢保（20年）標準保費表 (HK$300,000 保額)',
  'term-and-conditions.critical-illness.term-ci': 'Bowtie 危疾保',
  'term-and-conditions.critical-illness.term-ci-plus':
    'Bowtie 危疾保 - 多重保障',
  'term-and-conditions.critical-illness.term-ci-max': '早期及多重危疾保',
  'term-and-conditions.critical-illness.bb-ci': '標準保費表',
  'term-and-conditions.critical-illness.juvenile-ci': '標準保費表',
  'term-and-conditions.parent-medical.parent-medical-standard': '基本版',
  'term-and-conditions.parent-medical.parent-medical-advance': '升級版',
  'term-and-conditions.social-proof.vhis-flexi-regular':
    '根據 Bowtie 投保平台數據，截至 2023 年 12 月 31 日，{percentage}% 年齡介乎 {min_age} 至 {max_age} 歲的顧客選擇 Bowtie 自願醫保 - 靈活計劃（基本），為最多人選擇的 Bowtie 自願醫保計劃（以同年齡層的「標準計劃」、「靈活計劃-基本」、「靈活計劃 - 升級」投保人數作計算）。',
  'term-and-conditions.social-proof.vhis-flexi-premium-semi-private':
    '根據 Bowtie 投保平台數據，截至 2023 年 12 月 31 日，{percentage}% 年齡介乎 {min_age} 至 {max_age} 歲的顧客選擇 Bowtie Pink 自願醫保（半私家房），為最多人選擇的 Bowtie Pink 自願醫保計劃（以同年齡層的「Bowtie Pink 自願醫保」投保人數作計算）。',
  'term-and-conditions.social-proof.term-ci-max':
    '根據 Bowtie 投保平台數據，於 2024 年 1 月 1 日至 2024 年 5 月 13 日期間，{percentage}% 年齡介乎 {min_age} 至 {max_age} 歲的顧客選擇 Bowtie 早期及多重危疾保，為最多人選擇的 Bowtie 危疾保（以同年齡層的「Bowtie 危疾保」投保人數作計算）。',
  'term-and-conditions.social-proof.cancer-fighter-300':
    '根據 Bowtie 投保平台數據，截至 2023 年 12 月 31 日，{percentage}% 年齡介乎 {min_age} 至 {max_age} 歲的顧客選擇 Bowtie 戰癌 300，為最多人選擇的 Bowtie 癌症醫保計劃（以同年齡層的「Bowtie 戰癌保」投保人數作計算）。',
  'link.ia.levy':
    'https://www.ia.org.hk/tc/aboutus/role/financial_arrangements.html#1',
  'link.vhis.standard':
    'https://www.bowtie.com.hk/assets/product/vhis-standard/Premium-Schedule-Standard-03-ZH.pdf',
  'link.vhis.flexi-regular':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi/Premium-Schedule-Flexi-Regular-05-ZH.pdf',
  'link.vhis.flexi-plus':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi/Premium-Schedule-Flexi-Plus-05-ZH.pdf',
  'link.vhis.flexi-premium-ward':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/Premium-Schedule-Bowtie-Pink-Ward-01.pdf',
  'link.vhis.flexi-premium-semi-private':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/premium-schedule-bowtie-pink-semi-private-02.pdf',
  'link.vhis.flexi-premium-private':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/premium-schedule-bowtie-pink-private-02.pdf',
  'link.medical.cancer-fighter-100':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-100-01.pdf',
  'link.medical.cancer-fighter-200':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-200-01.pdf',
  'link.medical.cancer-fighter-300':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-300-01.pdf',
  'link.accidental-medical.touch-wood-protector':
    'https://www.bowtie.com.hk/assets/product/touch-wood-protector/Premium-Schedule-Touch-Wood-Protector-01.pdf',
  'link.life.term-life':
    'https://www.bowtie.com.hk/assets/product/term-life/Premium-Schedule-Term-Life-$1,000,000-03.pdf',
  'link.life.term-level-life-5':
    'https://www.bowtie.com.hk/assets/product/term-level-life-5/premium-schedule.pdf',
  'link.life.term-level-life-10':
    'https://www.bowtie.com.hk/assets/product/term-level-life-10/premium-schedule.pdf',
  'link.life.term-level-life-20':
    'https://www.bowtie.com.hk/assets/product/term-level-life-20/premium-schedule.pdf',
  'link.critical-illness.term-ci':
    'https://www.bowtie.com.hk/assets/product/term-ci/Premium-Schedule-Term-Critical-Illness-500,000-02.pdf',
  'link.critical-illness.term-ci-plus':
    'https://www.bowtie.com.hk/assets/product/term-ci-plus/Premium-Schedule-Term-CI-Multiple-Cover-500,000-02.pdf',
  'link.critical-illness.term-ci-max':
    'https://www.bowtie.com.hk/assets/product/term-ci-max/Premium-Schedule-Term-CI-Early-Stage-Multiple-Cover-500,000-02.pdf',
  'link.life.last-wish-rider':
    'https://www.bowtie.com.hk/assets/product/lastwish/Premium-Schedule-Last-Wish-Rider-300%2C000-01.pdf',
  'link.life.last-wish-rider-5':
    'https://www.bowtie.com.hk/assets/product/lastwish/premium-schedule-last-wish-rider-5.pdf',
  'link.life.last-wish-rider-10':
    'https://www.bowtie.com.hk/assets/product/lastwish/premium-schedule-last-wish-rider-10.pdf',
  'link.life.last-wish-rider-20':
    'https://www.bowtie.com.hk/assets/product/lastwish/premium-schedule-last-wish-rider-20.pdf',
  'riders.title': '附加保障 (如適用)',
  'riders.title.vhis': '加購年度身體檢查及自選健康服務（價值$4220）',
  'riders.details.vhis': '詳情',

  'marketing-page-anchor-link.recommendation.description.vhis': '未揀到？',
  'marketing-page-anchor-link.recommendation.description.life': '幾多先夠？',
  'marketing-page-anchor-link.recommendation.description.critical-illness':
    '幾多先夠？',
  'marketing-page-anchor-link.vhis-product-choices.description.vhis':
    '未揀到？',
  'marketing-page-anchor-link.term-level-life-premium-explanation.description.life':
    ' ',
  'marketing-page-anchor-link.recommendation.link.vhis': '精算師幫你分析',
  'marketing-page-anchor-link.recommendation.link.life':
    '精算師幫你分析所需保障額',
  'marketing-page-anchor-link.recommendation.link.critical-illness':
    '精算師幫你分析所需保障額',
  'marketing-page-anchor-link.vhis-product-choices.link.vhis':
    '邊個自願醫保適合你？ → ',
  'marketing-page-anchor-link.term-level-life-premium-explanation.link.life':
    '選擇適合自己嘅保障期',

  'social-proof-message': '🔥熱門・{percentage}% 同齡人會揀',

  'counter.second': '秒',
  'counter.minute': '分',
  'counter.hour': '時',
  'counter.day': '天',

  'variable_attribute.flexi.title': '靈活計劃',
  'variable_attribute.pink.title': 'Bowtie Pink',
  'variable_attribute.pink.remark': '有自付費',

  'age.option_label.unborn': '未出生 (18-31周)',
  'age.option_label.0': '0 (已出生15 天)',
};
